import React, { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Offcanvas } from 'react-bootstrap';
import './Nav.css';

const Nav: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="container-xl d-flex align-items-center justify-content-between" style={{ height: 'var(--nav-height)' }}>

        <Link to="/" className="nav__logo" onClick={close}>
          <img src="/images/logo-white.png" alt="Pace Plan LLC" className="nav__logo-img" />
        </Link>

        {/* Desktop links */}
        <nav className="nav__links d-none d-lg-flex align-items-center" aria-label="Primary navigation">
          <NavLink to="/" end onClick={close}>Home</NavLink>
          <NavLink to="/services" onClick={close}>Services</NavLink>
          <NavLink to="/portfolio" onClick={close}>Portfolio</NavLink>
          <NavLink to="/about" onClick={close}>About Us</NavLink>
          <NavLink to="/blog" onClick={close}>Blog</NavLink>
          <Link to="/contact" className="btn btn-brand-primary nav__cta ms-3" onClick={close}>Get a Quote</Link>
        </nav>

        {/* Mobile: quote button + hamburger */}
        <div className="d-flex align-items-center gap-2 d-lg-none">
          <Link to="/contact" className="btn btn-brand-primary nav__cta" onClick={close}>Get a Quote</Link>
          <button
            className={`nav__hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(v => !v)}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* Mobile offcanvas */}
      <Offcanvas show={menuOpen} onHide={close} placement="end" className="nav__mobile">
        <Offcanvas.Body className="d-flex flex-column justify-content-center p-4">
          <nav className="d-flex flex-column">
            <NavLink to="/" end onClick={close}>Home</NavLink>
            <NavLink to="/services" onClick={close}>Services</NavLink>
            <NavLink to="/portfolio" onClick={close}>Portfolio</NavLink>
            <NavLink to="/about" onClick={close}>About Us</NavLink>
            <NavLink to="/blog" onClick={close}>Blog</NavLink>
            <NavLink to="/contact" onClick={close} className="mobile-cta">Get a Free Quote →</NavLink>
          </nav>
          <div className="nav__mobile-contact mt-4 d-flex flex-column gap-2">
            <a href="tel:3464194499">(346) 419-4499</a>
            <a href="mailto:paceplanllcgroup@gmail.com">paceplanllcgroup@gmail.com</a>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </header>
  );
};

export default Nav;
